/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type CurrencySelector_user = {
    readonly id: string;
    readonly serviceId: string | null;
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly " $refType": "CurrencySelector_user";
};
export type CurrencySelector_user$data = CurrencySelector_user;
export type CurrencySelector_user$key = {
    readonly " $data"?: CurrencySelector_user$data;
    readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "CurrencySelector_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '3a8ac1876dcc70c5f03e88f37725caf1';
export default node;
